import logo from "../../logo.svg";
export default logo;

export const navigation = [
    { name: 'Support', href: '/support', current: false },
    { name: 'Packages', href: '/packages', current: false },
    { name: 'Sell on PX Stores', href: '#', current: true },
  ]
  